<br />
<div class="row">
  <div class="col-md-10 offset-md-2 text-left  col-12">
    <h1 class="title">
      <span *ngIf="!userIdParam">CREATE ACCOUNT</span>
      <span *ngIf="userIdParam">EDIT ACCOUNT</span>
    </h1>
  </div>
</div>
<br />
<div class="row">
  <div class="col-md-2"></div>
  <div class="col-md-8 col-12">
    <div class="card">
      <div class="card-body text-center">
        <div class="row">
          <div class="col-md-11 offset-md-1">

            <form class="edit-user" name="edit-user" style="margin-top:10px;" #f="ngForm" novalidate
                  [mustMatch]="['email', 'confirmEmail', 'false']"
                  [mustMatch2]="['newPassword', 'confirmPassword', 'true']"
                  [passwordStrength]="['password']"
                  (ngSubmit)="validateForm(f)">


              <input type="text" style="display:none">
              <input type="password" style="display:none">

              <div class="form-group row text-right">
                <label for="inputFirstName" class="col-sm-3 col-form-label">*First Name:</label>
                <div *ngIf="isAdmin; else textFirstName" class="col-md-5 col-sm-10">
                  <input type="text" class="form-control" name="firstName" id="inputFirstName" placeholder="First Name"
                         [(ngModel)]="user.firstName" #firstName="ngModel" required>
                  <div *ngIf="f.touched && firstName.invalid" class="invalid-form-field">
                    <span *ngIf="firstName.errors.required">First Name is required!</span>
                  </div>
                </div>
                <ng-template #textFirstName>
                  <div class="text-left my-auto col-md-5 col-sm-10">{{user.firstName}}</div>
                </ng-template>
              </div>
              <div class="form-group row text-right">
                <label for="inputLastName" class="col-sm-3 col-form-label">*Last Name:</label>
                <div *ngIf="isAdmin; else textLastName" class="col-md-5 col-sm-10">
                  <input type="text" class="form-control" name="lastName" id="inputLastName" placeholder="Last Name"
                         [(ngModel)]="user.lastName" #lastName="ngModel" required>
                  <div *ngIf="f.touched && lastName.invalid" class="invalid-form-field">
                    <span *ngIf="lastName.errors.required">Last Name is required!</span>
                  </div>
                </div>
                <ng-template #textLastName>
                  <div class="text-left my-auto col-md-5 col-sm-10">{{user.lastName}}</div>
                </ng-template>
              </div>
              <div class="form-group row text-right">
                <label for="inputEmail" class="col-sm-3 col-form-label">*Email:</label>
                <div *ngIf="isAdmin; else textEmail" class="col-md-5 col-sm-10">
                  <input type="text" class="form-control" name="email" id="inputEmail" placeholder="Email"
                         [(ngModel)]="user.email" #email="ngModel" required>
                  <div *ngIf="f.touched && email.invalid" class="invalid-form-field">
                    <span *ngIf="email.errors.required">Email is required!</span>
                    <span *ngIf="email.errors.email">Email must be a valid email address.</span>
                  </div>
                </div>
                <ng-template #textEmail>
                  <div class="text-left my-auto col-md-5 col-sm-10">{{user.email}}</div>
                </ng-template>
              </div>
              <div *ngIf="isAdmin" class="form-group row text-right">
                <label for="inputConfirmEmail" class="col-sm-3 col-form-label">*Confirm Email:</label>
                <div class="col-md-5 col-sm-10">
                  <input type="text" class="form-control" name="confirmEmail" id="inputConfirmEmail" placeholder="Email"
                         [(ngModel)]="user.confirmEmail" #confirmEmail="ngModel" required email>
                  <div *ngIf="f.touched && confirmEmail.invalid" class="invalid-form-field">
                    <span *ngIf="confirmEmail.errors.required">Confirm Email is required!</span>
                    <span *ngIf="confirmEmail.errors.email">Confirm Email must be a valid email address.</span>
                    <span *ngIf="confirmEmail.errors.mustMatch">Confirm Email must match Email.</span>
                  </div>
                </div>
              </div>
              <div class="form-group row text-right">
                <label for="inputRoles" class="col-sm-3 col-form-label">*Role(s):</label>
                <div class="col-md-5 col-sm-10 text-left ">

                  <div *ngIf="!isAdmin" style="padding-top:7px;">
                    <div *ngFor="let role of roleLabels | sort:'order'">{{role}}</div>
                  </div>
                  <div *ngIf="isAdmin" class="odp-material-checkbox-group">
                    <mat-checkbox *ngFor="let role of roles; let i = index"
                                  [id]="role.name + 'Chkbox'" [name]="role.name"
                                  (change)="addRemoveRole(role.name)"
                                  [checked]="user.roles.includes(role.name)">
                      {{role.description}}
                      
                    </mat-checkbox>
                  </div>

                </div>
              </div>






              <div *ngIf="hidePasswordFields" class="col-md-5 col-sm-10 offset-md-3 text-left " style="margin-bottom:10px;">
                <button type="button" class="btn btn-success" (click)="resetUserPassword()">
                  <span *ngIf="isAdminForSelf || !isAdmin">Change password</span>
                  <span *ngIf="!isAdminForSelf && isAdmin">Change user's password</span>
                </button>
              </div>

              <div *ngIf="!hidePasswordFields">
                <div class="form-group row text-left">
                  <div class="jumbotron offset-md-2 col-md-6" style="margin-bottom: 1rem !important;">
                    <h6><b>Password requirements:</b></h6>
                    <ol>
                      <li>Minimum of 15 characters.</li>
                      <li>At least 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number.</li>
                      <li>Cannot match last 10 passwords.</li>
                      <li>Cannot match a password in the last year.</li>
                    </ol>
                  </div>
                </div>
                <div *ngIf="isAdminForSelf || isSelf" class="form-group row text-right">
                  <label for="inputCurrentPassword" class="col-sm-3 col-form-label">*Old Password:</label>
                  <div class="col-md-5 col-sm-10">
                    <input type="password" class="form-control" name="currentPassword" id="inputCurrentPassword" placeholder="Current Password"
                           [requiredIf]="!hidePasswordFields || !isAdminForSelf" [(ngModel)]="user.currentPassword" #currentPassword="ngModel" required>
                    <div *ngIf="f.touched  && currentPassword.invalid" class="invalid-form-field">
                      Old Password is required.
                    </div>
                  </div>
                </div>
                <div class="form-group row text-right">
                  <label for="inputPassword" class="col-sm-3 col-form-label">*New Password:</label>
                  <div class="col-md-5 col-sm-10">
                    <input type="password" class="form-control" name="newPassword" id="inputPassword" placeholder="Password"
                           [requiredIf]="!hidePasswordFields"
                           [(ngModel)]="user.newPassword" #newPassword="ngModel" minlength="15" required>
                    <div *ngIf="f.touched  && newPassword.invalid" class="invalid-form-field">
                      <span *ngIf="newPassword.errors.required">New Password is required.</span>
                      <span *ngIf="newPassword.errors.minlength">New Password must be at least 15 characters long.</span>
                      <span *ngIf="newPassword.errors.passwordStrength">Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number.</span>
                    </div>
                  </div>
                </div>
                <div class="form-group row text-right">
                  <label for="inputConfirmPassword" class="col-sm-3 col-form-label">*Confirm New Password:</label>
                  <div class="col-md-5 col-sm-10">
                    <input type="password" class="form-control" name="confirmPassword" id="inputConfirmPassword" placeholder="Confirm Password"
                           [requiredIf]="!hidePasswordFields" [(ngModel)]="user.confirmPassword" #confirmPassword="ngModel">
                    <div *ngIf="f.touched && confirmPassword.invalid" class="invalid-form-field">
                      <span *ngIf="confirmPassword.errors.mustMatch">Confirm Password must match Password.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row text-right" *ngIf="isAdmin">
                <label for="inputActive" class="col-sm-3 col-form-label">Active:</label>
                <div class="col-md-5 col-sm-10 text-left" style="padding-top:8px;">
                  <mat-radio-group name="IsActiveMatRadioGroup" [(ngModel)]="user.isEnabled" #radioGroup="matRadioGroup" tabindex="0">
                    <mat-radio-button (click)=enableUser(true) name="activeYes"
                                      [checked]="user.isEnabled"
                                      [value]="true">Yes</mat-radio-button>
                    <mat-radio-button (click)=enableUser(false) name="activeNo"
                                      [checked]="!user.isEnabled"
                                      [value]="false"
                                      style="margin-left:30px !important;">No</mat-radio-button>
                  </mat-radio-group>
                </div>

              </div>

              <div class="form-group row text-left" *ngIf="isAdmin && isLocked">
                <div class="text-left offset-3 col-8" style="padding-top:8px;">
                  <mat-checkbox name="unlockAccount" [(ngModel)]="user.isLockedOut">
                    Account locked for {{loginConfiguration.lockoutDurationInMinutes}} minutes due to {{loginConfiguration.maxFailedAccessAttempts}} failed login attempts within {{loginConfiguration.failedAccessAttemptWindowInMinutes}} minutes
                  </mat-checkbox>
                </div>
              </div>

              <div class="row" *ngIf="isAdmin && userIdParam">
                <span class="col-sm-3 text-right">Last Login Date:</span>
                <span class="col-sm-5 text-left">{{user.lastLoginDateString}}</span>
              </div>

              <br />
              <div class="row">
                <div class="col-md-2 offset-md-4">
                  <button *ngIf="isAdmin" type="button" class="btn btn-danger btn-block"
                          [routerLink]='["/account/search"]'>
                    Cancel
                  </button>
                  <button *ngIf="!isAdmin" type="button" class="btn btn-danger btn-block"
                          [routerLink]='["/home/actions"]'>
                    Cancel
                  </button>
                  <br />
                </div>
                <div class="col-md-2">
                  <button type="submit" class="btn btn-primary btn-block">
                    <span *ngIf="!userIdParam">Create</span>
                    <span *ngIf="userIdParam">Update</span>
                  </button>
                </div>
              </div>
            </form>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
